import React from 'react';
import I18n from 'i18n-js';
import { Button } from 'grab-ui';
import css from './oops-view.less';
import Header from '../components/header/header';
import { sendGAErrorBackExpired } from '../common/utils/google-analytics-helper';

const handleOnClick = () => {
  sendGAErrorBackExpired();
};
const ExpiredView = () => (
  <div className={css.container}>
    <Header />
    <div className={css.message}>
      <h2> {I18n.t('expired.oops')} </h2>
      <h5>{I18n.t('expired.message')} </h5>
      <a href="https://express.grab.com">
        <Button onClick={() => handleOnClick()} type="primary">
          {I18n.t('error.backToHome')}
        </Button>
      </a>
    </div>
  </div>
);
export default ExpiredView;
